import { IconBrandWordmark } from './wordmark';
import { IconBrandMark } from './mark';
import { IconBrandMark3d } from './mark3d';

export const IconBrand = {
  BrandWordmark: IconBrandWordmark,
  BrandMark: IconBrandMark,
  BrandMark3d: IconBrandMark3d,
};
